/* __next_internal_client_entry_do_not_use__ tokens,themeSettings,ColorModeContext,useMode auto */ import montserrat from 'next/font/google/target.css?{"path":"app/[lng]/application/theme.ts","import":"Montserrat","arguments":[{"weight":["300","400","500","600","700"],"style":["normal","italic"],"subsets":["latin"]}],"variableName":"montserrat"}';
import { createContext, useState, useMemo } from "react";
import { createTheme } from "@mui/material/styles";
export const tokens = (mode)=>({
        ...mode === "dark" ? {
            // Colors to be added for dark mode
            primary: {
                main: "#FF9F24"
            },
            text: {
                main: "#000"
            },
            secondary: {
                main: "#F3F5FD"
            },
            button: {
                main: "#FF9F24",
                mainOnHower: "#F28C08",
                secondary: "#9BC4F5",
                secondaryOnHover: "#75B3FF",
                disabled: "#F3F4FD",
                danger: "#EB001B",
                dangerOnHover: "#A80014"
            }
        } : {
            primary: {
                main: "#FF9F24"
            },
            text: {
                main: "#000",
                secondary: "#FFF",
                disabled: "#B8BACE"
            },
            secondary: {
                main: "#F3F5FD"
            },
            button: {
                main: "#FF9F24",
                mainOnHower: "#F28C08",
                secondary: "#9BC4F5",
                secondaryOnHover: "#75B3FF",
                disabled: "#F3F4FD",
                danger: "#EB001B",
                dangerOnHover: "#A80014"
            }
        }
    });
export const themeSettings = (mode)=>{
    const colors = tokens(mode);
    return {
        palette: {
            mode: mode,
            ...mode === "dark" ? {
            } : {
                primary: {
                    main: colors.primary.main
                },
                secondary: {
                    main: colors.secondary.main
                },
                text: {
                    main: colors.text.main
                },
                button: {
                    main: colors.button.main,
                    mainOnHover: colors.button.mainOnHower,
                    secondary: colors.button.secondary,
                    secondaryOnHower: colors.button.secondaryOnHover,
                    disabled: colors.button.disabled
                }
            }
        },
        typography: {
            fontFamily: montserrat.style.fontFamily,
            fontSize: 14,
            fontWeight: 400,
            h2: {
                fontFamily: montserrat.style.fontFamily,
                fontSize: 18,
                fontWeight: 700
            },
            h3: {
                fontFamily: montserrat.style.fontFamily,
                fontSize: 24,
                fontWeight: 500
            },
            h5: {
                fontFamily: montserrat.style.fontFamily,
                fontSize: 20,
                fontWeight: 400
            },
            h6: {
                fontFamily: montserrat.style.fontFamily,
                fontSize: 14,
                fontWeight: 400
            }
        }
    };
};
export const ColorModeContext = createContext({
    toggleColorMode: ()=>{}
});
export const useMode = ()=>{
    const [mode, setMode] = useState("light");
    const colorMode = useMemo(()=>({
            toggleColorMode: ()=>setMode((prev)=>prev === "light" ? "dark" : "light")
        }), []);
    //@ts-ignore
    const theme = useMemo(()=>createTheme(themeSettings(mode)), [
        mode
    ]);
    return [
        theme,
        colorMode
    ];
};
